import type { DocumentRecord, DocumentRecordDetail, DocumentVersion } from '../model/documentSchema';

/** GET /api/documents/records — реестр НПА. Бэкенд: doc_type enum(npa/local/instruction); updated_date ISO. */
export const documentRecords: DocumentRecord[] = [
  {
    id: 1,
    title: 'Правила по охране труда при сварочных работах',
    docType: 'npa',
    details: 'Приказ Минтруда №44н от 11.12.2021',
    scope: 'Сварочные работы',
    updatedDate: '01.01.2022',
    status: 'ok',
  },
  {
    id: 2,
    title: 'Инструкция по ОТ для электросварщиков',
    docType: 'instruction',
    details: 'ИОТ-003-2024',
    scope: 'Цех №1',
    updatedDate: '15.03.2024',
    status: 'ok',
  },
  {
    id: 3,
    title: 'Инструкция по ОТ для токарей',
    docType: 'instruction',
    details: 'ИОТ-007-2025',
    scope: 'Цех №2',
    updatedDate: '10.02.2025',
    status: 'ok',
  },
  {
    id: 4,
    title: 'Положение о СУОТ АО «СМЗ»',
    docType: 'local',
    details: 'П-СУОТ-001-2023',
    scope: 'Вся организация',
    updatedDate: '20.06.2023',
    status: 'ok',
  },
  {
    id: 5,
    title: 'ТР ТС 019/2012 «О безопасности СИЗ»',
    docType: 'npa',
    details: 'Решение КТС №878',
    scope: 'СИЗ',
    updatedDate: '09.12.2012',
    status: 'ok',
  },
  {
    id: 6,
    title: 'ПБ 10-382-00 «Безопасность ПТМ»',
    docType: 'npa',
    details: 'Постановление Госгортехнадзора',
    scope: 'ПТМ, краны',
    updatedDate: '—',
    status: 'err',
  },
];

const documentRecordDetailExtras: Partial<
  Record<number, Pick<DocumentRecordDetail, 'ownerUnit' | 'nextReviewDate' | 'fileUri' | 'excerpt'>>
> = {
  1: {
    ownerUnit: 'Отдел охраны труда',
    nextReviewDate: '01.01.2026',
    fileUri: 'https://cdnstatic.rg.ru/uploads/attachments/201/90/02/61904.pdf',
    excerpt: 'Настоящие Правила устанавливают требования охраны труда при выполнении сварочных и паяльных работ...',
  },
  2: {
    ownerUnit: 'Цех №1',
    nextReviewDate: '15.03.2026',
    fileUri: 'https://www.elec.ru/library/direction/rd_153-34_0-03_231-00.pdf',
    excerpt: 'Инструкция распространяется на электросварщиков и их непосредственных руководителей.',
  },
  5: {
    ownerUnit: 'Отдел охраны труда',
    nextReviewDate: '—',
    fileUri: 'https://eec.eaeunion.org/upload/medialibrary/39d/TP-TS-SIZ.pdf',
    excerpt: 'Технический регламент Таможенного союза «О безопасности средств индивидуальной защиты».',
  },
};

export function buildDocumentRecordDetail(rec: DocumentRecord): DocumentRecordDetail {
  const extra = documentRecordDetailExtras[rec.id];
  return {
    ...rec,
    ownerUnit: extra?.ownerUnit ?? 'Структурное подразделение-владелец',
    nextReviewDate: extra?.nextReviewDate ?? '—',
    fileUri: extra?.fileUri,
    excerpt: extra?.excerpt ?? `Краткое содержание: документ «${rec.title}» в реестре.`,
  };
}

/** GET /api/documents/versions — версии документов. Бэкенд: publish_date ISO; is_local boolean. */
export const documentVersions: DocumentVersion[] = [
  {
    id: 1,
    documentTitle: 'ИОТ-007 для токарей',
    version: 'v3.0',
    publishDate: '10.02.2025',
    author: 'Иванова П.С.',
    changes: 'Обновлён раздел 4 (СИЗ)',
    status: 'ok',
    isLocal: true,
  },
  {
    id: 2,
    documentTitle: 'ИОТ-007 для токарей',
    version: 'v2.1',
    publishDate: '05.11.2024',
    author: 'Иванова П.С.',
    changes: 'Правка п.3.2',
    status: 'info',
    isLocal: true,
  },
  {
    id: 3,
    documentTitle: 'Положение о СУОТ',
    version: 'v2.0',
    publishDate: '20.06.2023',
    author: 'Иванова П.С.',
    changes: 'Новая редакция, добавлена гл.7',
    status: 'ok',
    isLocal: true,
  },
  {
    id: 4,
    documentTitle: 'Положение о СУОТ',
    version: 'v1.0',
    publishDate: '14.01.2020',
    author: 'Громов В.А.',
    changes: 'Первая редакция',
    status: 'info',
    isLocal: true,
  },
  {
    id: 5,
    documentTitle: 'Правила по ОТ при сварке (НПА)',
    version: 'v1.0',
    publishDate: '01.01.2022',
    author: '—',
    changes: 'Базовая версия',
    status: 'ok',
    isLocal: false,
  },
];
